<template>
  <div>
    <b-container fluid>
      <ConfiguratorStepTitle :step="configuratorStepNumber" title="DIMENSIONES" />

      <b-row align-h="center" class="mt-5">
        <b-col cols="10" lg="7">
          <b-row class="mb-4">
            <figure class="d-flex w-100 justify-content-center mb-2">
              <b-img
                :src="rampDimensionImg"
                alt="Dimension ramp"
                :style="{ width: anden.leveler == 'automatico' ? '90%' : '70%'}"
              />
            </figure>
            <div>
              <p class="configurator-label">
                <BlankIcon :field="form.dim_ramp === 0 ? null : form.dim_ramp" />
                <span v-if="anden.leveler === 'automatico'">
                  Ancho de minidock Hidráulico= DIMENSION A (ancho, sin bumper)
                </span>
                <span v-else>Dimensión de paso de rampa para el andén (C)</span>
                <font-awesome-icon
                :icon="['far', 'info-circle']"
                size="sm"
                class="text-info"
                v-b-tooltip.hover.v-dark.top='"Las opciones indicadas son las medidas que se pueden escoger según andenes que existen para realizar pedidos"'
              />
              </p>
              <b-form-group>
                <b-radio-group
                  size="lg"
                  v-model="form.dim_ramp"
                  :options="rampDimensionOptions"
                  stacked class="ml-4"
                >
                </b-radio-group>
              </b-form-group>
            </div>
          </b-row>
          <b-row class="mb-4">
            <figure class="d-flex w-100 justify-content-center mb-2">
              <b-img :src="AndenBordeDimenImg" alt="Dimensiones del andén" style="width: 90%;" />
            </figure>
            <div class="w-100">
              <p class="configurator-label">
                Detalle todas las condiciones correspondientes
              </p>
              <b-row class="border pt-1 rounded">
                <b-col>
                  <table class="table fs-14 table-borderless table-show table-sm w-100 mb-0"  style="font-size: 1rem">
                    <TableRowDimension
                      v-for="(dimension, index) in dimensions"
                      :class="index % 2 != 0 ? 'd-lg-none' : ''"
                      :dimension="dimension"
                      :key="dimension.value"
                      :index="index"
                      :disabled-input="!selectedDimensions.includes(dimension.value)"
                      :selectedDimensions="selectedDimensions"
                      :form="form"
                      @update:selectedDimensions="selectedDimensions = $event"
                    />
                  </table>
                </b-col>
                <b-col class="d-none d-lg-block" cols="12" lg="6">
                  <table class="table fs-14 table-borderless table-show table-sm w-100 mb-0"  style="font-size: 1rem">
                    <TableRowDimension
                      v-for="(dimension, index) in dimensions"
                      :index="index + 1"
                      :class="index % 2 == 0 ? 'd-lg-none' : ''"
                      :key="dimension.value"
                      :dimension="dimension"
                      :disabled-input="!selectedDimensions.includes(dimension.value)"
                      :selectedDimensions="selectedDimensions"
                      :form="form"
                      @update:selectedDimensions="selectedDimensions = $event"
                    />
                  </table>
                </b-col>
              </b-row>
            </div>
          </b-row>
          <b-row v-if="anden.leveler_type == 'fosa'" class="mb-4 w-100">
            <p class="configurator-label">Guía de Proyección de Foso para entradas en pendiente descendente</p>
            <div class="d-flex justify-content-center w-100">
              <div class="desnivel-container">
                <b-img :src="desnivelTypeImg" alt="Desnivel" class="desnivel-img" />

                <b-radio
                  v-model="form.desnivel_type"
                  value="declinacion"
                  class="d-radio d-radio-declinacion"
                  @change="$event === 'a nivel' ? form.desnivel = 0 : false"
                >
                  DECLINACIÓN
                </b-radio>
                <b-radio
                  v-model="form.desnivel_type"
                  value="a nivel"
                  class="d-radio d-radio-nivel"
                  @change="$event === 'a nivel' ? form.desnivel = 0 : false"
                >
                  A NIVEL
                </b-radio>
                <b-radio
                  v-model="form.desnivel_type"
                  value="inclinacion"
                  class="d-radio d-radio-inclinacion"
                  @change="$event === 'a nivel' ? form.desnivel = 0 : false"
                >
                  INCLINACIÓN
                </b-radio>
              </div>
            </div>
            <div
              v-if="form.desnivel_type !== 'a nivel'"
              class="image-reference-anden text-right w-100 mt-0 px-2"
              @click="openFullImageModal(desnivelGuideImg)"
            >
              (Imagen de referencia <font-awesome-icon :icon="['far', 'image']" fixed-width />)
            </div>
            <div v-if="form.desnivel_type !== 'a nivel'" class="w-100 px-2" style="border: 1px solid #dee2e6; border-radius: 10px;">
              <div class="d-flex mt-2 w-100 align-items-center justify-content-center">
                <p class="configurator-label mb-0 mr-2" >
                  <BlankIcon :field="validDesnivel ? 'active' : ''" />
                  % de Pendiente de la entrada
                </p>
                <b-input-group append="%" style="width: 180px;">
                  <b-input
                    v-model.number="form.desnivel" type="number" min="0" max="10" step="1"
                    :state="validDesnivel"
                  />
                </b-input-group>
              </div>
              <table class="table table-show table-sm w-100 mt-2"  style="font-size: 1rem">
                <tbody>
                  <tr>
                    <td class="font-bold">
                      Proyección del Foso (Excluye la Proyección del Bumper)
                    </td>
                    <td class="text-center" style="width: 95px;">{{ fosoMapper[form.desnivel] || 'no valido' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-row>
        </b-col>
      </b-row>
    </b-container>

    <ImageFullModal
      v-if="fullImage"
      :image-url="fullImage"
      @close-modal="fullImage = null"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ConfiguratorStepTitle from '../ConfiguratorStepTitle'
import BlankIcon from '../BlankIcon'
import missingPng from '../../../../../../public/images/original/missing.png'
import TableRowDimension from './TableRowDimension'
import ManualDimensionRampImage from 'images/andenes/manual_dim_ramp.webp'
import AutomaticDimensionRampImage from 'images/andenes/automatic_dim_ramp.webp'
import AndenBordeDimenImage from 'images/andenes/dimensions.webp'
import DesnivelTypeImage from 'images/andenes/desnivel_type.webp'
import desnivelGuideImage from 'images/andenes/desnivel_guide.webp'
import ImageFullModal from '../../../shared/ImageFullModal'

export default {
  name: 'Dimensions',
  components: { ConfiguratorStepTitle, BlankIcon, TableRowDimension, ImageFullModal },
  props: {
    updateConfigurable: Function
  },
  data () {
    return {
      form: {
        dim_ramp: 0,
        desnivel_type: 'a nivel',
        desnivel: 0,
        dim_a: 0,
        dim_b: 0,
        dim_c: 0,
        dim_d: 0,
        dim_e: 0,
        dim_f: 0,
        // dim_g: 0,
        // dim_h: 0,
        // dim_j: 0,
        // dim_k: 0,
        // dim_l: 0,
        // dim_m: 0
      },
      fosoMapper: {
        0: '0" 0 cm',
        1: '3" 7,6 cm',
        2: '4" 10,1 cm',
        3: '5" 12,7 cm',
        4: '6" 15,2 cm',
        5: '7" 17,7 cm',
        6: '8" 20,3 cm',
        7: '9" 22,8 cm',
        8: '10" 25,4 cm',
        9: '11" 27,9 cm',
        10: '12" 30,4 cm'
      },
      selectedDimensions: [],
      dimensions : [
        { text: 'Dim "A"', value: 'dim_a', description: 'Altura del andén', required: true },
        { text: 'Dim "B"', value: 'dim_b', description: 'Altura del andén, con respecto a la inclinación', required: true },
        { text: 'Dim "C"', value: 'dim_c', description: 'Distancia con rejilla', required: true },
        { text: 'Dim "D"', value: 'dim_d', description: 'Distancia con cambio de nivel', required: true },
        { text: 'Dim "E"', value: 'dim_e', description: 'Ancho de rejilla', required: true },
        { text: 'Dim "F"', value: 'dim_f', description: 'Distancia de patio de maniobras al andén', required: true },
        // { text: 'Dim "G"', value: 'dim_g', description: 'Longitud de la inclinación en el edificio', required: false },
        // { text: 'Dim "H"', value: 'dim_h', description: 'Altura de la inclinación en el edificio', required: false },
        // { text: 'Dim "J"', value: 'dim_j', description: 'saliente del voladizo', required: false },
        // { text: 'Dim "K"', value: 'dim_k', description: 'Altura del voladizo o hasta la calzada', required: false },
        // { text: 'Dim "L"', value: 'dim_l', description: 'Superficie del muelle hasta el drenaje de la zanja', required: false },
        // { text: 'Dim "M"', value: 'dim_m', description: 'Longitud del drenaje de la zanja', required: false }
      ],
      AndenBordeDimenImg: AndenBordeDimenImage,
      desnivelTypeImg: DesnivelTypeImage,
      desnivelGuideImg: desnivelGuideImage,
      fullImage: null
    }
  },
  mounted () {
    if (this.anden) {
      this.setForms()
    }
  },
  computed: {
    ...mapState({ anden: state => state.configurator.configurable }),
    ...mapGetters(['configuratorStepNumber']),
    missingImg () { return missingPng },
    validDesnivel () {
      if (this.form.desnivel === null || this.form.desnivel === undefined || this.form.desnivel === '') {
        return false
      }
      const num = Number(this.form.desnivel)
      return !isNaN(num) && num >= 0 && num <= 10;
    },
    rampDimensionOptions () {
      const defaultOptions = [
        { text: '66” (167 cm)', value: 167, type: '(Pedido Especial)' },
        { text: '72” (183 cm)', value: 183, type: '(Estándar)' },
        { text: '78” (198 cm)', value: 198, type: '(Pedido Especial)' }
      ]

      if (this.anden.leveler === 'automatico') {
        return defaultOptions.map(option => {
          option.text += ' + ancho de bumper (variable)'
          if (option.value === 183) {
            option.text += ' (ST)'
          }
          option.text += option.type
          return {
            text: ` ${option.text}`,
            value: option.value
          }
        })
      }

      return defaultOptions.map(option => {
        return {
          text: `${option.text} ${option.type}`,
          value: option.value
        }
      })
    },
    rampDimensionImg () {
      if (this.anden.leveler === 'automatico') {
        return AutomaticDimensionRampImage
      }
      return ManualDimensionRampImage
    }
  },
  methods: {
    setForms () {
      Object.entries(this.form).forEach(([key, value]) => {
        this.form[key] = this.anden[key]
      })
      this.setSelectedDimensions()
    },
    setSelectedDimensions () {
      const validDimensions = this.dimensions.map(d => d.value)
      validDimensions.forEach(d => {
        if (this.form[d] > 0) {
          this.selectedDimensions.push(d)
        }
      })
    },
    async update () {
      if (!this.formHasChanged()) return true

      const result = await this.updateConfigurable(this.form)
      return result
    },
    formHasChanged () {
      return Object.entries(this.form).some(([key, value]) => value !== this.anden[key])
    },
    openFullImageModal (image) {
      this.fullImage = image
    }
  }
}
</script>

<style lang="scss" scoped>
.desnivel-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24rem;
  height: auto;
  align-self: center;

  .desnivel-img {
    width: 100%;
    display: block;
  }
  .d-radio {
    position: absolute;
    font-size: 0.95rem;
  }
  .d-radio-declinacion {
    left: 0px;
    bottom: 15px;
  }
  .d-radio-nivel {
    left: 50%;
    transform: translateX(-50%);
    bottom: 15px;
  }
  .d-radio-inclinacion {
    right: 0px;
    bottom: 15px;
  }
}
.image-reference-anden {
  cursor: pointer;
  margin: 0;
  font-size: 0.9rem;
  color: #6e737b;

  &:hover {
    color: #163D7D;
    text-decoration: underline;
  }
}
</style>
